import { Grid } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionCardSkeleton from '../../components/section-card/SectionCardSkeleton'
import { useCardSkeletonColumns } from '../useSingleOrDoubleColumns'
import OtherInformationLoading from './OtherInformationLoading'

type Props = {
  isSingleCardPage?: boolean
  totalColumns?: number
}

export default function OtherInformationCardSkeleton({
  isSingleCardPage = true,
  totalColumns = 12,
}: Props): JSX.Element {
  const [t] = useTranslation()
  const columns = useCardSkeletonColumns(totalColumns)

  return (
    <Grid gutters="nano">
      <SectionCardSkeleton isSingleCardPage={isSingleCardPage} heading={t('tree-person.other-information.label')}>
        <OtherInformationLoading columns={columns} />
      </SectionCardSkeleton>
    </Grid>
  )
}
